// GLOBALS

var userLang = navigator.language || navigator.userLanguage;
var userLang = userLang.split('-')[0];
var values = [];
var country = null;
var lang = null;

// FUNCTIONS

function runCheckColor() {
  $('.extra-colors').each(function(index) {
    if ($(this).attr("data-checked") != "true") {
      checkColorAvailability($(this).data("parent-handle"), $(this).data("child-colors"));
    }
  });
}

function checkColorAvailability(handle, colors) {                  
  var i = 0;
  var results = [];
  var async = [];
  var available_colors = [];
  var child_colors = colors.replace('/','').split(',');

  child_colors.forEach(function(color) {
    if (handle && color) {
      async[i] = $.getJSON('/products/' + handle + '-' + color + '.js', function(product) {
        if (product.available) {
          available_colors.push(color);
        }
      })
      results.push(async[i]);
    i++;
    }
  });

  $.when.apply(this, results).done(function() {
    //console.log(handle + ' ' + available_colors);
    if (available_colors.length > 1) {
      $('p[data-parent-handle=' + handle + ']').text('+ ' + available_colors.length + ' COLORES' );
    }
    $('p[data-parent-handle=' + handle + ']').attr("data-checked", "true");
  });
  return;
}

function translateStoreSelectorFields(lang) {
  if (Spinal.availableLangs.includes(userLang)) {
    $('#country > option').each(function() { this.text = Spinal.translations[userLang]['country'][this.value]; });
    $('#lang > option').each(function() { this.text = Spinal.translations[userLang]['lang'][this.value]; });
    $('#store-selector > button').text(Spinal.translations[userLang]['button']);
  }
  showStoreSelector();
  return;
}

function showStoreSelector() {
  $('form#store-selector').css('display', 'flex');
  if($(window).width() >= 1007) {
    $('form#store-selector-sel').css('display', 'flex');
  }
}

function setStore(countryCode, langCode) {
  Cookies.set('sel-country', countryCode, { expires: 365 });
  Cookies.set('sel-language', langCode, { expires: 365 });
  return;
}

function redirectToSavedStore() {
  var selCountry = Cookies.get('sel-country');
  if (selCountry != undefined) {
    window.location.replace(Spinal.availableStores[selCountry].url + '?r=0');
  }
  return;
}

function redirectToStoreSelector() {
  window.location.replace('/pages/store-selector');
  return;
}

function fetchSelectorOverlay(context) {
  $.get('https://' + Shopify.shop + '/pages/store-selector', function(data) {
    setTimeout(function(){
      $('#store-selector-overlay').empty().append($('<div/>').append(data).find('#pre-home-body').append('<span id="close-pre-home-overlay"><svg style="width:21px;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close Icon Icon--close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></svg></span>'));
      if (context != undefined && context.detected_values != undefined && Spinal.availableStores[context.detected_values.country.handle.toLowerCase()] != undefined) {
        $('select#country-sel option[value=' + context.detected_values.country.handle.toLowerCase() + ']').prop('selected', true);
      } else {
        $('select#country-sel option[value=es]').prop('selected', true);
      }     
      $("#lang").chained("#country");
      addCloseSelectorListener();
    }, 2000);
  });
}

function fetchIBOverlay() {
  $.get('https://' + Shopify.shop + '/pages/ib-selector', function(data) {
    setTimeout(function(){
      $('#store-selector-overlay').empty().append($('<div/>').append(data).find('#pre-home-body').append('<span id="close-pre-home-overlay"><svg style="width:21px;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close Icon Icon--close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></svg></span>'));
      addCloseSelectorListener();
    }, 300);
  });
}

function showGenderSelector() {
  if (Spinal.availableLangs.includes(lang)) {
    $('.gender-selector').each(function() {
      $(this).children('span').text(Spinal.translations[lang]['gender'][$(this).data('gender')]);
    });
  }
  $('#pre-home-container').fadeOut(300);
  $('.gender-selector').on('click', function(){
    console.log($(this).data('gender'));
    // console.log(country);
    if(country == 'es' || country == 'pt' || country == 'be' || country == 'nl' || country == 'lu') {
      switch($(this).data('gender')) {
        case 'man':
          setStore(country, lang);
          if(country == 'es') {
            uri = Spinal.availableStores[country].url + '/pages/hombre';
          }
          else if(country == 'pt') {
            uri = Spinal.availableStores[country].url + '/pages/homem';
          }
          else if(country == 'be' || country == 'nl' || country == 'lu') {
            uri = Spinal.availableStores[country].url + '/pages/man';
          }
          break;
        case 'woman':
          setStore(country, lang);
          if(country == 'es') {
          uri = Spinal.availableStores[country].url + '/pages/mujer';
          }
          else if(country == 'pt') {
            uri = Spinal.availableStores[country].url + '/pages/mulher';
          }
          else if(country == 'be' || country == 'nl' || country == 'lu') {
            uri = Spinal.availableStores[country].url + '/pages/woman';
          }
          break;
      }
    } else {
      switch($(this).data('gender')) {
        case 'man':
          setStore(country, lang);
          uri = Spinal.availableStores[country].url + '?home=hombre';
          break;
        case 'woman':
          setStore(country, lang);
          uri = Spinal.availableStores[country].url + '?home=mujer';
          break;
      }
      uri = uri + '&r=0';
    }
  	window.location.href = uri;
  });
}

function translateGeoNotification(lang) {
  if (Spinal.availableLangs.includes(userLang)) {
    $('#spinal-geo-notification span[data-geo-message]').text(Spinal.translations[userLang]['geo']);
    $('#spinal-geo-notification a[data-geo-button]').text(Spinal.translations[userLang]['geo_button']);
  }
  return;
}

function addCloseSelectorListener() {
  $('#close-pre-home-overlay').click(function(){
    $('html').removeClass('no-scroll');
    $('#store-selector-overlay').remove();
    Cookies.set('sel-section', 1, { expires: 365 });
  }); 
}

function checkCookie(){
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled){ 
    document.cookie = "testcookie";
    cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
  }
  return cookieEnabled;
}

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

// ARRAY INCLUDE POLYFILL

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, "includes", {
    enumerable: false,
    value: function(obj) {
      var newArr = this.filter(function(el) {
        return el == obj;
      });
      return newArr.length > 0;
    }
  });
}